(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-home-canvas]');
  if (!roots.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canvasResize = window.EastDtcCanvasResize;
  var VB_W = 480;
  var VB_H = 360;

  var COLORS = {
    blue: '#4da3ff',
    blueLight: '#7ec8ff',
    red: '#e60012',
    redSoft: 'rgba(230,0,18,0.35)',
    panel: 'rgba(20,40,80,0.65)',
    panelStroke: 'rgba(126,200,255,0.4)',
    white: '#ffffff',
    whiteDim: 'rgba(255,255,255,0.35)',
    bg: 'rgba(0,0,0,0)'
  };

  function applyView(ctx, w, h, dpr) {
    var s = Math.min(w / VB_W, h / VB_H);
    var ox = (w - VB_W * s) / 2;
    var oy = (h - VB_H * s) / 2;
    ctx.setTransform(s * dpr, 0, 0, s * dpr, ox * dpr, oy * dpr);
  }

  function roundRect(ctx, x, y, rw, rh, r) {
    var rad = Math.min(r, rw / 2, rh / 2);
    ctx.beginPath();
    ctx.moveTo(x + rad, y);
    ctx.arcTo(x + rw, y, x + rw, y + rh, rad);
    ctx.arcTo(x + rw, y + rh, x, y + rh, rad);
    ctx.arcTo(x, y + rh, x, y, rad);
    ctx.arcTo(x, y, x + rw, y, rad);
    ctx.closePath();
  }

  function drawShopifyGlobal(ctx, t) {
    ctx.strokeStyle = 'rgba(77,163,255,0.25)';
    ctx.beginPath();
    ctx.ellipse(240, 190, 130, 50, 0, 0, Math.PI * 2);
    ctx.stroke();

    var dashOff = (t * 40) % 28;
    ctx.setLineDash([6, 8]);
    ctx.lineDashOffset = -dashOff;
    ctx.strokeStyle = COLORS.red;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(80, 190);
    ctx.quadraticCurveTo(240, 80, 400, 190);
    ctx.stroke();
    ctx.setLineDash([]);

    ctx.fillStyle = COLORS.red;
    ctx.beginPath();
    ctx.arc(80, 190, 8, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = COLORS.blue;
    ctx.beginPath();
    ctx.arc(400, 190, 8, 0, Math.PI * 2);
    ctx.fill();

    roundRect(ctx, 190, 150, 100, 80, 8);
    ctx.fillStyle = 'rgba(20,40,80,0.75)';
    ctx.fill();
    ctx.strokeStyle = COLORS.blueLight;
    ctx.lineWidth = 1.5;
    ctx.stroke();

    ctx.fillStyle = COLORS.white;
    ctx.font = '600 11px system-ui,sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('Shopify', 240, 198);
  }

  function drawAiDiscovery(ctx, t) {
    var pulse = 0.92 + 0.08 * Math.sin(t * 2);
    ctx.strokeStyle = 'rgba(77,163,255,0.25)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(240, 180, 120 * pulse, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(240, 180, 88, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(230,0,18,0.2)';
    ctx.stroke();

    var nodes = [
      [120, 120, 6, COLORS.blue],
      [360, 100, 5, COLORS.blueLight],
      [320, 260, 7, COLORS.red],
      [140, 250, 5, COLORS.blueLight]
    ];
    nodes.forEach(function (n, i) {
      var bob = Math.sin(t * 2 + i) * 3;
      ctx.fillStyle = n[3];
      ctx.shadowColor = n[3];
      ctx.shadowBlur = 10;
      ctx.beginPath();
      ctx.arc(n[0], n[1] + bob, n[2], 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.shadowBlur = 0;

    var grad = ctx.createRadialGradient(240, 180, 0, 240, 180, 18);
    grad.addColorStop(0, COLORS.blue);
    grad.addColorStop(1, COLORS.red);
    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.arc(240, 180, 14 + Math.sin(t * 3) * 2, 0, Math.PI * 2);
    ctx.fill();

    ctx.strokeStyle = COLORS.whiteDim;
    ctx.lineWidth = 2;
    ctx.beginPath();
    var scan = (Math.sin(t * 1.2) + 1) / 2;
    ctx.moveTo(60, 180);
    ctx.quadraticCurveTo(240, 60 + scan * 40, 420, 180);
    ctx.stroke();
  }

  function drawGeoEngines(ctx, t) {
    var panels = [
      { x: 40, y: 50, w: 140, h: 90, label: 'ChatGPT', lx: 110, ly: 100, stroke: COLORS.panelStroke },
      { x: 300, y: 40, w: 140, h: 90, label: 'Perplexity', lx: 370, ly: 90, stroke: 'rgba(230,0,18,0.35)' },
      { x: 170, y: 200, w: 140, h: 90, label: 'AI Overview', lx: 240, ly: 250, stroke: COLORS.panelStroke }
    ];
    panels.forEach(function (p, i) {
      var float = Math.sin(t * 1.5 + i * 1.2) * 4;
      roundRect(ctx, p.x, p.y + float, p.w, p.h, 12);
      ctx.fillStyle = COLORS.panel;
      ctx.fill();
      ctx.strokeStyle = p.stroke;
      ctx.lineWidth = 1;
      ctx.stroke();
      ctx.fillStyle = COLORS.blueLight;
      ctx.font = '10px system-ui,sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(p.label, p.lx, p.ly + float);
    });

    var links = [
      [180, 95, 300, 85],
      [110, 140, 240, 200],
      [370, 130, 280, 200]
    ];
    ctx.strokeStyle = COLORS.whiteDim;
    ctx.lineWidth = 2;
    ctx.setLineDash([8, 6]);
    ctx.lineDashOffset = -(t * 30) % 28;
    links.forEach(function (l) {
      ctx.beginPath();
      ctx.moveTo(l[0], l[1]);
      ctx.lineTo(l[2], l[3]);
      ctx.stroke();
    });
    ctx.setLineDash([]);

    var pr = 22 + Math.sin(t * 2.5) * 4;
    ctx.strokeStyle = COLORS.red;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(240, 170, pr, 0, Math.PI * 2);
    ctx.stroke();
  }

  function drawAnalytics(ctx, t) {
    roundRect(ctx, 50, 60, 380, 220, 14);
    ctx.fillStyle = 'rgba(8,16,32,0.8)';
    ctx.fill();
    ctx.strokeStyle = 'rgba(77,163,255,0.3)';
    ctx.stroke();

    var bars = [
      { x: 90, h: 30 },
      { x: 145, h: 45 },
      { x: 200, h: 35 },
      { x: 255, h: 60, red: true },
      { x: 310, h: 50 },
      { x: 365, h: 70 }
    ];
    bars.forEach(function (b, i) {
      var bh = b.h * (0.75 + 0.25 * Math.sin(t * 2 + i * 0.7));
      ctx.fillStyle = b.red ? 'rgba(230,0,18,0.45)' : 'rgba(77,163,255,0.5)';
      ctx.fillRect(b.x, 280 - bh, 28, bh);
    });

    function linePoints(baseY, amp, phase) {
      var pts = [];
      for (var i = 0; i < 6; i++) {
        var x = 80 + i * 60;
        var y = baseY + Math.sin(t * 1.8 + phase + i) * amp;
        pts.push([x, y]);
      }
      return pts;
    }

    function strokeLine(pts, color, width) {
      ctx.strokeStyle = color;
      ctx.lineWidth = width;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(pts[0][0], pts[0][1]);
      for (var j = 1; j < pts.length; j++) ctx.lineTo(pts[j][0], pts[j][1]);
      ctx.stroke();
    }

    strokeLine(linePoints(240, 35, 0), COLORS.blue, 3);
    strokeLine(linePoints(250, 25, 0.5), COLORS.red, 2);
  }

  function drawContentEntity(ctx, t) {
    roundRect(ctx, 120, 50, 240, 260, 8);
    ctx.fillStyle = 'rgba(12,24,48,0.85)';
    ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,0.2)';
    ctx.stroke();

    var lines = [
      { y: 100, w: 180, alpha: 0.35 },
      { y: 130, w: 150, alpha: 0.2 },
      { y: 160, w: 170, alpha: 0.2 }
    ];
    lines.forEach(function (ln, i) {
      var prog = prefersReducedMotion ? 1 : Math.min(1, ((t * 0.8 + i * 0.25) % 1.2));
      ctx.strokeStyle = 'rgba(255,255,255,' + ln.alpha + ')';
      ctx.lineWidth = 4;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(150, ln.y);
      ctx.lineTo(150 + ln.w * prog, ln.y);
      ctx.stroke();
    });

    roundRect(ctx, 150, 200, 80, 24, 4);
    ctx.fillStyle = 'rgba(230,0,18,0.35)';
    ctx.fill();
    ctx.strokeStyle = COLORS.red;
    ctx.stroke();
    roundRect(ctx, 240, 200, 90, 24, 4);
    ctx.fillStyle = 'rgba(77,163,255,0.25)';
    ctx.fill();
    ctx.strokeStyle = COLORS.blue;
    ctx.stroke();

    ctx.fillStyle = COLORS.white;
    ctx.font = '9px system-ui,sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('Entity', 190, 216);
    ctx.fillText('Schema', 285, 216);

    var scanY = 70 + ((t * 50) % 200);
    ctx.fillStyle = 'rgba(77,163,255,0.12)';
    ctx.fillRect(125, scanY, 230, 3);
  }

  function drawSocialAeo(ctx, t) {
    ctx.strokeStyle = 'rgba(255,255,255,0.12)';
    ctx.beginPath();
    ctx.arc(240, 180, 100, 0, Math.PI * 2);
    ctx.stroke();
    ctx.strokeStyle = 'rgba(230,0,18,0.2)';
    ctx.beginPath();
    ctx.arc(240, 180, 70, 0, Math.PI * 2);
    ctx.stroke();

    var sats = [
      { label: 'in', color: COLORS.red, angle: t * 0.8 },
      { label: 'fb', color: COLORS.blue, angle: t * 0.8 + 2.1 },
      { label: 'YT', color: COLORS.blueLight, angle: t * 0.8 + 4.2 }
    ];
    sats.forEach(function (s) {
      var x = 240 + Math.cos(s.angle) * 100;
      var y = 180 + Math.sin(s.angle) * 100;
      ctx.fillStyle = s.color;
      ctx.beginPath();
      ctx.arc(x, y, 16, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = COLORS.white;
      ctx.font = '9px system-ui,sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(s.label, x, y + 4);
    });

    ctx.fillStyle = 'rgba(230,0,18,0.2)';
    ctx.strokeStyle = COLORS.red;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(240, 180, 24, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
    ctx.fillStyle = COLORS.white;
    ctx.fillText('AEO', 240, 186);
  }

  var SCENES = {
    'shopify-global': drawShopifyGlobal,
    'ai-discovery': drawAiDiscovery,
    'geo-engines': drawGeoEngines,
    analytics: drawAnalytics,
    'content-entity': drawContentEntity,
    'social-aeo': drawSocialAeo
  };

  function drawScene(ctx, id, w, h, t, dpr) {
    // 透明背景：让动效融入星空/玻璃卡，避免出现“黑色膏药”底板
    ctx.clearRect(0, 0, Math.max(1, Math.floor(w * dpr)), Math.max(1, Math.floor(h * dpr)));

    ctx.save();
    applyView(ctx, w, h, dpr);
    (SCENES[id] || drawAiDiscovery)(ctx, t);
    ctx.restore();
  }

  function initRoot(root) {
    var canvas = root.querySelector('.home-services__canvas');
    if (!canvas) return;

    var id = root.getAttribute('data-home-canvas') || 'ai-discovery';
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var running = false;
    var rafId = null;
    var start = performance.now();
    var cssW = 0;
    var cssH = 0;

    function resize() {
      var size;
      if (canvasResize) {
        size = canvasResize.measureCanvasSize(canvas, root, {
          minWidth: 40,
          minHeight: 12,
          fallbackViewportWidth: false,
          squareFromWidth: true
        });
      } else {
        var cw = Math.floor(canvas.clientWidth);
        var ch = Math.floor(canvas.clientHeight);
        if (cw >= 40 && ch >= 12) {
          size = { width: cw, height: ch };
        } else {
          var rect = root.getBoundingClientRect();
          size = {
            width: Math.max(Math.floor(rect.width), 1),
            height: Math.max(Math.floor(rect.height), 1)
          };
        }
      }
      cssW = size.width;
      cssH = size.height;
      if (cssH < 12) {
        cssH = Math.round(cssW * (VB_H / VB_W));
      }
      if (canvasResize) {
        canvasResize.applyCanvasDisplaySize(canvas);
      } else {
        canvas.style.width = '100%';
        canvas.style.height = '100%';
      }
      canvas.width = Math.max(1, Math.round(cssW * dpr));
      canvas.height = Math.max(1, Math.round(cssH * dpr));
    }

    function resizeIfNeeded() {
      if (canvasResize && !canvasResize.canvasNeedsResize(canvas, cssW, cssH, dpr)) {
        return false;
      }
      var prevW = cssW;
      var prevH = cssH;
      resize();
      return prevW !== cssW || prevH !== cssH;
    }

    function frame(now) {
      if (!running) return;
      resizeIfNeeded();
      var t = (now - start) / 1000;
      drawScene(ctx, id, cssW, cssH, t, dpr);
      rafId = requestAnimationFrame(frame);
    }

    function startLoop() {
      if (running) return;
      running = true;
      resize();
      rafId = requestAnimationFrame(frame);
    }

    function stopLoop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    if (prefersReducedMotion) {
      drawScene(ctx, id, cssW, cssH, 0, dpr);
    } else {
      startLoop();
    }

    function onLayoutSync(fromTabVisible) {
      resize();
      if (prefersReducedMotion) {
        drawScene(ctx, id, cssW, cssH, 0, dpr);
      } else if (fromTabVisible) {
        startLoop();
      }
    }

    var tabLayout = canvasResize ? canvasResize.createLayoutScheduler(onLayoutSync) : null;

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        if (document.hidden) return;
        if (tabLayout) tabLayout.schedule();
        else onLayoutSync(false);
      });
      ro.observe(root);
    }

    window.addEventListener('resize', function () {
      if (tabLayout) tabLayout.schedule();
      else onLayoutSync(false);
    });

    if (tabLayout) {
      tabLayout.bindLifecycle({
        onHidden: function () {
          if (!prefersReducedMotion) stopLoop();
        },
        onVisible: function () {
          if (prefersReducedMotion) tabLayout.syncWhenVisible();
          else {
            stopLoop();
            tabLayout.syncWhenVisible();
          }
        }
      });
    } else {
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopLoop();
        else if (!prefersReducedMotion) startLoop();
      });
    }
  }

  roots.forEach(initRoot);
})();
